import Repository from '../axios'
import {defaultPagination} from "@/constants/config";
import staff from "../apis/staff";

const  resource = "/admin/customers";
const  single_resource = "/admin/customer";

export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getDropdownCustomers(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/customer-list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getPotentialCustomers(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/potential_customers?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerUsers(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/users?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerSites(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/sites?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  customerSiteStatusChange(id) {
    return Repository.put(`${single_resource}/site/${id}/status`)
  },
  getCustomerProjectBrief(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/project_briefs?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getProjectBriefList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/project_brief/list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  changeProjectBriefStatus(id, status) {
    return Repository.put(`${single_resource}/project_briefs/${id}/${status}`)
  },
  getCustomerSiteDetails(id) {
    return Repository.get(`${single_resource}/sites/${id}`)
  },
  updateCustomerSite(id, payload) {
    return Repository.put(`${single_resource}/sites/${id}`, payload)
  },
  deleteCustomerSite(id) {
    return Repository.delete(`${single_resource}/sites/${id}`)
  },
  createCustomerSite(payload) {
    return Repository.post(`${single_resource}/sites`, payload)
  },
  createCustomerProjectBrief(payload) {
    return Repository.post(`${single_resource}/project_briefs`, payload)
  },
  getCustomerProjectBriefDetails(id) {
    return Repository.get(`${single_resource}/project_briefs/${id}`)
  },
  getApplicationItems(id) {
    return Repository.get(`admin/customer/project-brief-application/${id}`)
  },
  updateCustomerProjectBrief(id, payload) {
    return Repository.put(`${single_resource}/project_briefs/${id}`, payload)
  },
  customerUserWelcomeEmailResend(email) {
    return Repository.put(`${single_resource}/${email}/customer-user-resend`)
  },
  customerUserInvitationSend(email) {
    return Repository.put(`${single_resource}/${email}/customer-user-invite`)
  },
  getCustomerUser(id){
    return Repository.get(`${single_resource}/users/${id}`)
  },
  updateCustomerUser(id, payload){
    return Repository.put(`${single_resource}/users/${id}`, payload)
  },
  deleteCustomerUser(id) {
    return Repository.delete(`${single_resource}/users/${id}`)
  },
  createCustomer(payload){
    return Repository.post(`${resource}`, payload)
  },
  createPotentialCustomer(payload){
    return Repository.post(`${single_resource}/potential_customers`, payload)
  },
  changeCustomerUserStatus(id, status) {
    return Repository.put(`${single_resource}/users/${id}/${status}`)
  },
  getIndustrySectorsSubSectors() {
    return Repository.get(`${single_resource}/industrial_sectors`)
  },
  getIndustrySectors(filterQuery) {
    return Repository.get(`${single_resource}/industrial_sector?${filterQuery}`)
  },
  getIndustrySubSectors(payload) {
    return Repository.post(`${single_resource}/industrial_sub_sector`, payload)
  },
  getIndustrySectorsAndSubSectors() {
    return Repository.get(`${single_resource}/industrial_sectors`)
  },
  getCustomerDetails(id){
    return Repository.get(`${resource}/${id}`)
  },
  updateCustomerDetails(id, payload){
    return Repository.put(`${resource}/${id}`, payload)
  },
  changeCustomerStatus(id, status) {
    return Repository.put(`${single_resource}/${id}/${status}`)
  },
  updateOtifTracker(id, payload) {
    return Repository.put(`${single_resource}/${id}/update-otif-tracker`, payload)
  },
  createCustomerUser(payload){
    return Repository.post(`${single_resource}/users`, payload)
  },
  getPotentialCustomerDetails(id) {
    return Repository.get(`${single_resource}/potential_customers/${id}`)
  },
  updatePotentialCustomerDetails(id, payload) {
    return Repository.put(`${single_resource}/potential_customers/${id}`, payload)
  },

  getCustomerAccountCredit(id){
    return Repository.get(`${single_resource}/account_credits/${id}`)
  },
  createCustomerAccountCredit(payload){
    return Repository.post(`${single_resource}/account_credits`, payload)
  },
  updateCustomerAccountCredit(id, payload){
    return Repository.put(`${single_resource}/account_credits/${id}`, payload)
  },

  getAccountLimitRequestList(id, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${single_resource}/credit_requests?customer_id=${id}&paginate=${pagination}&page=${pageNumber}`)
  },
  getAccountLimitRequest(id){
    return Repository.get(`${single_resource}/credit_requests/${id}`)
  },
  createAccountLimitRequest(payload){
    return Repository.post(`${single_resource}/credit_requests`, payload)
  },
  updateAccountLimitRequest(id, payload){
    return Repository.put(`${single_resource}/credit_requests/${id}`, payload)
  },
  statusChangeAccountLimitRequest(id, payload, status){
    return Repository.put(`${single_resource}/credit_requests/${id}/${status}`, payload)
  },
  getCustomerCreditLimitRequests(pageNumber = 1, pagination = defaultPagination, filterQuery) {
    return Repository.get(`/admin/report/credit-limit?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },

  getCustomerRoles() {
    return Repository.get(`${single_resource}/roles`)
  },

  customerBulkActionAccountHandler(payload){
    return Repository.put(`${single_resource}/bulk-action/account-handler`, payload)
  },

  //CREDIT NOTES
  getCustomerCreditNoteList(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/customer_credit_notes?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerCreditNote(id) {
    return Repository.get(`${single_resource}/customer_credit_notes/${id}`)
  },
  createCustomerCreditNote(payload) {
    return Repository.post(`${single_resource}/customer_credit_notes`, payload)
  },
  updateCustomerCreditNote(id, payload) {
    return Repository.put(`${single_resource}/customer_credit_notes/${id}`, payload)
  },
  statusChangeCreditNote(id, payload, status){
    return Repository.put(`${single_resource}/customer_credit_note/${id}/${status}`, payload)
  },
  linkCustomerCreditNoteToOrders(id, payload) {
    return Repository.put(`${single_resource}/customer_credit_note/${id}/link-product-order`, payload)
  },
  getCreditNotePdfData(secret_code) {
    return Repository.get(`${single_resource}/customer_credit_note/${secret_code}/pdf_data`)
  },
  getCreditNotePdfDataById(id) {
  return Repository.get(`${single_resource}/customer_credit_note/${id}/pdf`)
  },
  sendCustomerCreditNote(id,payload) {
    return Repository.post(`${single_resource}/customer_credit_note/${id}/send-credit-note`,payload)
  },
  getCreditNoteList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/customer-credit-notes-list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCreditNoteEmailLogs(id) {
    return Repository.get(`${single_resource}/customer_credit_note/${id}/sent-email-logs`)
  },

  //sample requests

  getListOfSamples(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/sample_orders?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getAllListOfSamples(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/sample_order_list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerSampleOrder(id) {
    return Repository.get(`${single_resource}/sample_orders/${id}`)
  },
  createCustomerSampleOrder(payload) {
    return Repository.post(`${single_resource}/sample_orders`, payload)
  },
  updateCustomerSampleOrder(id, payload) {
    return Repository.put(`${single_resource}/sample_orders/${id}`, payload)
  },
  statusChangeCustomerSampleOrders(id, status){
    return Repository.put(`${single_resource}/sample_order/${status}/${id}`)
  },
  getSampleDeliveryAddresses(id) {
    return Repository.get(`${single_resource}/sample_delivery_addresses?customer_id=${id}`)
  },

  getSampleList(customer_id = null, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/samples-catalogue?${customer_id ? 'customer-id=' + customer_id : ''}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getItemsInItemsCart(queries) {
    return Repository.get(`${single_resource}/sample_carts?${queries}`)
  },
  addFormulationsToCart(payload) {
    return Repository.post(`${single_resource}/sample_carts`, payload)
  },
  removeFormulationsFromCart(id) {
    return Repository.delete(`${single_resource}/sample_carts/${id}`)
  },
  updateFormulationSampleCart(id, payload) {
    return Repository.put(`${single_resource}/sample_carts/${id}`, payload)
  },
  getSampleOrder(id) {
    return Repository.get(`${single_resource}/sample_orders/${id}`)
  },
  changeSampleOrderStatus(status, id, send_specs = false) {
    return Repository.put(`${single_resource}/sample-order/${id}/${status}`, { send_specs })
  },
  updateSampleOrderItems(id, payload){
    return Repository.put(`${single_resource}/sample_order/${id}/items`,payload)
  },
  updateSampleOrderItemDosageInfo(item_id, payload){
    return Repository.put(`${single_resource}/sample-order-item/${item_id}/update-dosage-info`,payload)
  },
  updateSampleOrderShippingDetails(id, payload){
    return Repository.put(`${single_resource}/sample-order/${id}/shipping-details`,payload)
  },
  updateSampleOrderFeedback(id, payload) {
    return Repository.put(`${single_resource}/sample-order/${id}/feedback`, payload)
  },
  sendProductSpecToUsers(id, payload) {
    return Repository.put(`${single_resource}/sample-order/${id}/resend-prod-specs`, payload)
  },

  getSpecSendEmailLog(sample_order_id, pageNumber = 1, pagination = 150) {
    return Repository.get(`${single_resource}/sample-order/${sample_order_id}/sent-email-logs?paginate=${pagination}&page=${pageNumber}`)
  },

  // PRODUCT CONTRACTS
  getListOfProductContracts(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/product_contracts?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerContractedProductList(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/contract_product_list?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerContractedProductListSelectedIds(id, ids) {
    return Repository.get(`${single_resource}/contract_product_list?customer_id=${id}&selected_fg_ids=${ids}`)
  },
  statusChangeCustomerProductContracted(id, status){
    return Repository.put(`${single_resource}/product_contract/${status}/${id}`)
  },
  createCustomerProjectContract(payload) {
    return Repository.post(`${single_resource}/product_contracts`, payload)
  },
  updateCustomerProjectContract(id, payload) {
    return Repository.put(`${single_resource}/product_contracts/${id}`, payload)
  },
  getCustomerProjectContract(id) {
    return Repository.get(`${single_resource}/product_contracts/${id}`)
  },

  //product orders

  getAllProductOrders(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/product_order_list?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getAllProductOrdersReadyToDispatch(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/product_order_list_dispatch?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },

  getListOfProductOrders(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/product_orders?customer_id=${id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getListOfProductOrdersNoPagination(id) {
    return Repository.get(`${single_resource}/product_orders?customer_id=${id}&is_paginate=0&is_internal_search=0`)
  },

  getCustomerProductOrder(id) {
    return Repository.get(`${single_resource}/product_orders/${id}`)
  },
  cloneCustomerProductOrder(id, payload) {
    return Repository.post(`${single_resource}/product_order/${id}/clone`, payload)
  },
  createCustomerProductOrder(payload) {
    return Repository.post(`${single_resource}/product_orders`, payload)
  },
  updateCustomerProductOrder(id, payload) {
    return Repository.put(`${single_resource}/product_orders/${id}`, payload)
  },
  updateCustomerProductOrderItems(id, payload) {
    return Repository.put(`${single_resource}/product_order_content/${id}`, payload)
  },
  // new order update APIs
  removeItemFromCustomerProductOrder(item_id) {
    return Repository.delete(`${single_resource}/order-items/${item_id}`)
  },
  updateItemFromCustomerProductOrder(item_id, payload) {
    return Repository.put(`${single_resource}/order-items/${item_id}`, payload)
  },
  AddItemToCustomerProductOrder(order_id, payload) {
    return Repository.post(`${single_resource}/product_orders/${order_id}/order-items`, payload)
  },
  statusChangeCustomerProductOrders(id, status){
    return Repository.put(`${single_resource}/product_order/${id}/${status}`)
  },
  changeRmOrderHandleType(id) {
    return Repository.put(`${single_resource}/product_order/${id}/item_status_handle`)
  },
  productOrdersItemStatusChange(id, payload) {
    return Repository.put(`${single_resource}/product_order_item/${id}/status`, payload)
  },
  updateCustomerProductOrderItemIncoterm(id, payload) {
    return Repository.put(`${single_resource}/product-order-item/${id}/item-incoterm`, payload)
  },
  getDemandStockData(payload) {
    return Repository.post(`/admin/inventory/stock/product-stock/stock-demands`, payload)
  },
  addAdditionalCostToProductOrder(order_id, payload) {
    return Repository.put(`${single_resource}/product_order/${order_id}/invoice_details`, payload)
  },

  getCustomerProductDeliveryAddresses(id) {
    return Repository.get(`${single_resource}/product_delivery_addresses?customer_id=${id}`)
  },

  getCustomerDeliveryAddressNames(id = null) {
    return Repository.get(`${single_resource}/delivery_addresses/names${id ? `?customer_id=${id}` : ''}`)
  },

  getListOfProductCatalogue(id, filterQuery, is_credit_required = 1) {
    return Repository.get(`${single_resource}/product_catalogue?customer_id=${id}&is_credit_required=${is_credit_required}&${filterQuery}`)
  },
  getListOfProductCatalogueSalesQuote(id, filterQuery) {
    return Repository.get(`${single_resource}/sales/sale-quote/${id}/catalogue?${filterQuery}`)
  },
  getListOfCartProductCatalogue(payload, is_credit_required = 1) {
    return Repository.post(`${single_resource}/product_catalogue/item_ids?is_credit_required=${is_credit_required}`, payload)
  },
  getListOfCartProductCatalogueSalesQuote(id, payload) {
    return Repository.post(`${single_resource}/sales/sale-quote/${id}/catalogue-item-ids`, payload)
  },

  getItemsInProductCart(id) {
    return Repository.get(`${single_resource}/product_carts?customer_id=${id}`)
  },
  addFormulationsToProductCart(payload) {
    return Repository.post(`${single_resource}/product_carts`, payload)
  },
  removeFormulationsFromProductCart(id) {
    return Repository.delete(`${single_resource}/product_carts/${id}`)
  },
  updateFormulationsQuantityInProductCart(id, payload) {
    return Repository.put(`${single_resource}/product_carts/${id}`, payload)
  },
  updateProductOrderContent(id, payload) {
    return Repository.put(`${single_resource}/product_order_content/${id}`, payload)
  },
  getProductOrderItemLog(id) {
    return Repository.get(`/admin/log/customer/product_order/item/${id}`)
  },
  getProductOrderLog(id) {
    return Repository.get(`/admin/log/customer/product_order/${id}`)
  },

  // bespole price
  getListOfBespokeList(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${single_resource}/bespoke_prices?customer_id=${id}&${filterQuery}&paginate=${pagination}&page=${pageNumber}&sort=${sort}`)
  },
  addCustomerBespokePrice(payload) {
    return Repository.post(`${single_resource}/bespoke_prices`, payload)
  },
  getBespokePriceDetails(id) {
    return Repository.get(`${single_resource}/bespoke_prices/${id}`)
  },
  updateCustomerBespokePrice(id, payload) {
    return Repository.put(`${single_resource}/bespoke_prices/${id}`, payload)
  },
  removeCustomerBespokePrice(id) {
    return Repository.delete(`${single_resource}/bespoke_prices/${id}`)
  },
  getBespokePriceHistory(customer_id, formulation_id, paginate = 50) {
    return Repository.get(`${single_resource}/bespoke-price/price-log?customer-id=${customer_id}&formulation-id=${formulation_id}&paginate=${paginate}`)
  },
  addCustomerDraftBespokePrice(payload) {
    return Repository.post(`${single_resource}/draft-prices`, payload)
  },
  getDraftBespokePriceList(paginate = defaultPagination, customer_id, formulation_id, type = 'bespoke-price') {
    return Repository.get(`${single_resource}/draft-prices?paginate=${paginate}&customer-id=${customer_id}&formulation-id=${formulation_id}&type=${type}`)
  },
  removeCustomerDraftBespokePrice(id) {
    return Repository.delete(`${single_resource}/draft-prices/${id}`)
  },

  getCustomerProductList(id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${single_resource}/bespoke_price_list?customer_id=${id}&${filterQuery}&paginate=${pagination}&page=${pageNumber}`)
  },

  //PRIVATE FORMULATIONS
  getCustomerPrivateFormulation(id, filterQuery) {
    return Repository.get(`${single_resource}/private_formulations?customer_id=${id}&${filterQuery}`)
  },
  getPrivateFormulationList(filterQuery) {
    return Repository.get(`${single_resource}/private_formulation_list?${filterQuery}`)
  },
  addPrivateFormulationToCustomer(payload) {
    return Repository.post(`${single_resource}/private_formulations`, payload)
  },
  deletePrivateFormulationFromCustomer(id) {
    return Repository.delete(`${single_resource}/private_formulations/${id}`)
  },

  //INVOICE
  getProductOrderInvoices(order_id) {
    return Repository.get(`${single_resource}/product_orders/${order_id}/invoices`)
  },
  createInvoice(order_id, payload) {
    return Repository.post(`${single_resource}/product_orders/${order_id}/invoices`, payload)
  },
  updateInvoice(invoice_id, payload) {
    return Repository.put(`${single_resource}/invoices/${invoice_id}`, payload)
  },
  invoiceStatusChange(id, status_name) {
    return Repository.put(`${single_resource}/product_order/invoice/${id}/${status_name}`)
  },
  invoiceSentCustomer(invoice_id, payload) {
    return Repository.put(`${single_resource}/product_order/invoice/${invoice_id}/sent`, payload)
  },
  orderConfirmationSentCustomer(invoice_id, payload) {
    return Repository.post(`${single_resource}/product_order/${invoice_id}/send-order-confirmation-pdf`, payload)
  },
  invoiceResendCustomer(invoice_id, payload) {
    return Repository.post(`${single_resource}/product-order/${invoice_id}/send-invoice`, payload)
  },

  //PRODUCT DETAILS
  getCustomerProductDetailsList(id, filterQuery) {
    return Repository.get(`${single_resource}/product_details?customer_id=${id}&${filterQuery}`)
  },
  getALlCustomerProductList(id, filterQuery) {
    return Repository.get(`${single_resource}/product_detail_list?customer_id=${id}&${filterQuery}`)
  },
  createCustomerProductDetail(payload) {
    return Repository.post(`${single_resource}/product_details`, payload)
  },
  deleteCustomerProductDetail(id) {
    return Repository.delete(`${single_resource}/product_details/${id}`,)
  },
  getCustomerProductDetail(id) {
    return Repository.get(`${single_resource}/product_details/${id}`,)
  },
  updateCustomerProductDetail(id, payload) {
    return Repository.put(`${single_resource}/product_details/${id}`, payload)
  },
  getProductOrderInvoiceData(secret_code) {
    return Repository.get(`${single_resource}/product-order/${secret_code}/pdf-data`)
  },
  getProductOrderConfirmationData(product_order_secret_code) {
    return Repository.get(`${single_resource}/product_order/${product_order_secret_code}/order-confirmation-data`)
  },
  getProductOrderInvoiceEmailLog(id){
    return Repository.get(`${single_resource}/product-order/${id}/sent-email-logs`)
  },
  getProductOrderConfirmationSentLog(order_id){
    return Repository.get(`${single_resource}/product_order/${order_id}/sent-email-logs`)
  },

  // sales quote APIs
  getListOfSalesQuote(pageNumber = 1, filterQuery, pagination = defaultPagination ) {
    return Repository.get(`${single_resource}/sales/sale-quotes?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfSalesQuoteWithCustomer(customer_id, pageNumber = 1, filterQuery, pagination = defaultPagination ) {
    return Repository.get(`${single_resource}/sales/sale-quotes?customer_id=${customer_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSalesQuote(payload) {
    return Repository.post(`${single_resource}/sales/sale-quotes`, payload)
  },
  createSalesOrderFromQuote(id) {
    return Repository.post(`${single_resource}/sales/sale-quote/${id}/add-to-cart`)
  },
  updateSalesQuote(id, payload) {
    return Repository.put(`${single_resource}/sales/sale-quotes/${id}`, payload)
  },
  getSalesQuote(id) {
    return Repository.get(`${single_resource}/sales/sale-quotes/${id}`)
  },
  sendSalesQuote(id, payload) {
    return Repository.post(`${single_resource}/sales/sale-quote/${id}/send_sale_quote_pdf`, payload)
  },
  getSalesQuoteData(key) {
    return Repository.get(`${single_resource}/sales/sale-quote/${key}/data`)
  },
  getListOfSalesQuoteEmailLog(id) {
    return Repository.get(`${single_resource}/sales/sale-quote/${id}/sent_email_logs`)
  },
  salesQuoteStatusChange(id, status){
    return Repository.put(`${single_resource}/sales/sale-quote/${id}/${status}`)
  },
  getSalesQuotePdf(id){
    return Repository.get(`${single_resource}/sales/sale-quote/${id}/pdf`,{
      responseType: 'blob'
    })
  },
  getSalesOrderPdf(id){
    return Repository.get(`${single_resource}/product_order/${id}/get-order-confirmation-pdf`,{
      responseType: 'blob'
    })
  },
  getSalesInvoicePdf(id){
    return Repository.get(`${single_resource}/product-order/${id}/pdf`,{
      responseType: 'blob'
    })
  },

  productOrderItemChangeRequestStatusChange(id, status, payload = {}) {
    return Repository.put(`${single_resource}/change-request/${id}/${status}`, payload)
  },

  getListOfSamplesForLead(lead_id, pageNumber = 1, filterQuery = '', pagination = 150, sort = '') {
    return Repository.get(`${single_resource}/sample_orders?customer_lead_id=${lead_id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },

  // Enquiries
  getListOfCustomerEnquiries(customer_id, filterQuery, pageNumber = 1, pagination = defaultPagination, sort = '') {
    return Repository.get(`/admin/customer/crm/enquiries?customer-id=${customer_id}&paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getCustomerEnquiryDetails(enquiry_id) {
    return Repository.get(`/admin/customer/crm/enquiries/${enquiry_id}`)
  },
  createCustomerEnquiry(payload) {
    return Repository.post(`/admin/customer/crm/enquiries`, payload)
  },
  updateCustomerEnquiry(enquiry_id, payload) {
    return Repository.put(`/admin/customer/crm/enquiries/${enquiry_id}`, payload)
  },

  //sample order invoices
  getSampleOrderInvoices(order_id) {
    return Repository.get(`${single_resource}/sample-orders/${order_id}/sample-invoices`)
  },
  createSampleOrderInvoice(order_id, payload) {
    return Repository.post(`${single_resource}/sample-orders/${order_id}/sample-invoices`, payload)
  },
  getSampleOrderInvoice(id) {
    return Repository.get(`${single_resource}/sample-invoices/${id}`)
  },
  updateSampleOrderInvoice(id, payload) {
    return Repository.put(`${single_resource}/sample-invoices/${id}`, payload)
  },
  getSampleOrderInvoiceData(secret_code) {
    return Repository.get(`${single_resource}/sample-order/invoice/${secret_code}/pdf-data`)
  },
  getSampleOrderInvoicePdf(id) {
    return Repository.get(`${single_resource}/sample-order/invoice/${id}/pdf`, {
      responseType: 'blob'
    })
  },
  sendSampleOrderInvoice(id, payload) {
    return Repository.put(`${single_resource}/sample-order/invoice/${id}/sent`, payload)
  },
  reSendSampleOrderInvoice(id, payload) {
    return Repository.post(`${single_resource}/sample-order/invoice/${id}/send-invoice`, payload)
  },
  sampleInvoiceStatusChange(id, status_name) {
    return Repository.put(`${single_resource}/sample-order/invoice/${id}/${status_name}`)
  },


  // approveSupplier(id) {
  //   return Repository.put(`/admin/supplier/${id}/approve`)
  // },
  // ReActiveSupplier(id) {
  //   return Repository.put(`/admin/supplier/${id}/re-activate`)
  // },
  // approveSupplierSite(id) {
  //   return Repository.put(`/admin/supplier/saq/${id}/approve`)
  // },
  // NotApproveSupplier(id) {
  //   return Repository.put(`/admin/supplier/${id}/not-approve`)
  // },
  // DeActivateSupplier(id) {
  //   return Repository.put(`/admin/supplier/${id}/suspend`)
  // },
  // NotApproveSite(id) {
  //   return Repository.put(`/admin/supplier/saq/${id}/not-approve`)
  // },
  // updateSupplier(id, payload){
  //   return Repository.put(`${resource}/${id}`, payload)
  // },
  // updateSupplierBasicDetails(id,payload){
  //   return Repository.put(`${resource}/${id}`, payload)
  // },
  // getBasicSupplierDetails(id) {
  //   return Repository.get(`${resource}/${id}`)
  // },
  uploadFile(file) {
    return Repository.post(`/admin/supplier/file-upload`, file, {headers: {
        'Content-Type': 'multipart/form-data'
      }})
  },
  downloadBespokeSheet(id) {
    return Repository.get(`/admin/export/data/customer/${id}/bespoke-prices`, {
      responseType:'blob'
    })
  },
  downloadContractSheet(id) {
    return Repository.get(`/admin/export/data/customer/${id}/contract-prices`, {
      responseType:'blob'
    })
  },
  getCountryCodes() {
    return Repository.get('/admin/country-code')
  },
  getSosChangeReasons(params = {}) {
    return Repository.get(`/admin/system_setting/customer/sales-order-change-reasons`, {
      params: {
        paginate: 10,
        is_paginate: 1,
        ...params
      }
    })
  },
  // Create SOS change reason
  createSosChangeReason(payload) {
    return Repository.post(`/admin/system_setting/customer/sales-order-change-reasons`, payload)
  },

  // Update SOS change reason
  updateSosChangeReason(id, payload) {
    return Repository.put(`/admin/system_setting/customer/sales-order-change-reasons/${id}`, payload)
  },

  // Delete SOS change reason
  deleteSosChangeReason(id) {
    return Repository.delete(`/admin/system_setting/customer/sales-order-change-reasons/${id}`)
  },
  //change customer currency
  updateCustomerCurrency(customer_id, payload){
    return Repository.put(`${single_resource}/${customer_id}/change-currency`, payload)
  },
  checkCurrencyChangePosibility(customer_id){
    return Repository.get(`${single_resource}/${customer_id}/check-currency-change`)
  }
};
